<div class="min-h-[calc(100dvh-10rem)] max-w-[624px] mx-auto mt-4 px-4 sm:px-0 overflow-x-hidden">

  <app-stepper
    *ngIf="steps.length > 1"
    [steps]="steps"
    [currentStep]="currentStep"
    (stepChange)="goToStep($event)"
  ></app-stepper>

  <div class="mt-8 flex-1">
    <div *ngIf="loading" class="flex justify-center items-center h-32">
      <app-loading></app-loading>
    </div>
    
    <router-outlet *ngIf="!loading"></router-outlet>
  </div>

</div>
